import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-head-tooltip-template',
    templateUrl: './head-tooltip-template.component.html',
    styleUrl: './head-tooltip-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeadTooltipTemplateComponent {
	@Input() model: any[] = []; // Array of data points at the hovered x-value

  get entries() {
    return this.model ?? []; // Return empty array, if null/undefined
  }

  getExtraData(entry: any): string[] {
    //Safely get the extra data, if exists.
    if (entry && entry.original && Array.isArray(entry.original)) {
        return entry.original;
    }
    return [];
  }
}
